
import Vue from 'vue'
import BaseInputOutlined from '@root/src/components/inputs/BaseInputOutlined.vue'
import phoneValidator, { isValidPhone } from '../../../../helpers/validators/phoneValidator'
import ValidationInput from '../../../../components/inputs/ValidationInput.vue'

export default Vue.extend({
    components: { BaseInputOutlined, ValidationInput },
    data: () => ({
        warn: false,
        mode: '',
    }),
    props: {
        value: { type: Object },
    },
    methods: {
        onChange() {
            if (this.value.mode === 'Боевой') {
                this.value.testModePhone = ''
            }
            this.mode = this.value.mode
            this.emitValidationUpdate()
        },
        checkWarn(e) {
            this.warn = e
            this.emitValidationUpdate()
        },
        change(e) {
            console.log(e)
            this.emitValidationUpdate()
        },
        clear() {
            this.value.mode = 'Боевой'
            this.mode = 'Боевой'
            this.value.testModePhone = ''
            this.emitValidationUpdate()
        },
        emitValidationUpdate() {
            const isValid = this.value.mode === 'Боевой' || 
                           (this.value.mode === 'Тестовый' && this.value.testModePhone && isValidPhone(this.value.testModePhone))
            this.$emit('validation-updated', isValid)
        }
    },
    setup(props, { emit }) {
        return {phoneValidator}
    },
    mounted() {
        if (!this.value.mode) {
            this.value.mode = 'Боевой'
        }
        this.mode = this.value.mode
        this.emitValidationUpdate()
    },
})
